/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback } from 'react';
import { sessionsPageSelectors } from '../../../../app/page/page-storage/sessions/sessions.selectors';
import { meetingSimpleSelectors } from '../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { useSelect, useSelectWithParams } from '../../../../utils/selector.utils';
import { AgendaList } from './AgendaList';
import { NextSession } from './NextSession';
import { IMeetingManagementProps } from './types';
import MicrosoftTeamsIcon from '../../../resources/images/microsoft-office365-icon.svg';
import ZoomIcon from '../../../resources/images/zoom-icon.svg';
import GoogleMeetIcon from '../../../resources/images/google-meet-icon.svg';
import { IoPlayCircleSharp } from 'react-icons/io5';
import { WrikeFolderTab } from '../../common/navigation-bars/MeetigDashboardNavbar/WrikeFolderTab';
import { isMemberAnAdmin } from '../../../../utils/user.utils';
import { IUser } from '../../../../app/resource/user/user.types';
import { authSelectors } from '../../../../app/auth/auth.selectors';
import { userSelectors } from '../../../../app/resource/user/user.selectors';

export const MeetingManagement: FunctionComponent<IMeetingManagementProps> = ({ meetingId }) => {
  const nextSessionId = useSelect(sessionsPageSelectors.selectNextSessionId);
  const lastSessionId = useSelect(sessionsPageSelectors.selectLastSessionId);
  const loggedUserId = useSelect(authSelectors.selectLoggedUser) as IUser['id'];
  const loggedUser = useSelectWithParams(userSelectors.selectResourceById, loggedUserId) as IUser;
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId);
  const link = meeting?.sharepointUrl ? meeting.sharepointUrl : '/home';
  const isAdmin = loggedUser && meeting && isMemberAnAdmin(loggedUser, meeting);

  return (
    <div className="panel vto-text">
      <div className="panel-header no-border justify-between">
        <div>
          <h2 className="bold">Meeting Management</h2>
        </div>
        <div className="flex align-center">
          {isAdmin && <WrikeFolderTab meetingId={meetingId} />}
          <VideoConferenceLink link={link} />
        </div>
      </div>
      <div className="row">
        <NextSession meetingId={meetingId} nextSessionId={nextSessionId} lastSessionId={lastSessionId} />
        <AgendaList meetingId={meetingId} />
      </div>
    </div>
  );
};

const VideoConferenceLink: FunctionComponent<{ link: string }> = ({ link }) => {
  const regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
  const check = regex.test(link);
  const callAlert = useCallback(() => {
    alert('Video Conference Link is invalid');
  }, []);

  let color,
    icon: string | undefined = undefined;
  if (link.includes('teams.microsoft.com')) {
    color = 'purple-bg';
    icon = MicrosoftTeamsIcon;
  } else if (link.includes('meet.google.com')) {
    color = 'googleGreen-bg';
    icon = GoogleMeetIcon;
  } else if (link.includes('zoom.us')) {
    color = 'darkBlue-bg';
    icon = ZoomIcon;
  }

  return (
    <div className="ml-auto flex aic h100">
      {check ? (
        <>
          {icon ? (
            <img src={icon} alt="" className="img-fluid h100" style={{ height: 32 }} />
          ) : (
            <IoPlayCircleSharp size="40" color="#f4a743" />
          )}
          <a
            className={`btn btn-md btn-border mr-0 ${color ?? 'yellow-bg'}`}
            title="Video Conference Link"
            href={link}
            target="_blank"
          >
            Video Conference Link
          </a>
        </>
      ) : (
        <a className={`btn btn-md btn-border mr-0 ${color}`} title="Video Conference Link" onClick={callAlert}>
          <i className="icon2-video mr-1"></i>
          Video Conference Link
        </a>
      )}
    </div>
  );
};
